import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTop } from "./components";
import ApolloProvider from "./Apollo";
import AppProvider from "./Context";
import {RegisterBlock} from './node/RegisterBlock.js';
import BookingEngine from "./layout/BookingEngine.js";

RegisterBlock('.booking-widget', BookingEngine);

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <ApolloProvider>
        <AppProvider>
          <App />
        </AppProvider>
      </ApolloProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// On development, insert the server css.
if (process.env.NODE_ENV === "development") {
  const css = [
    "/wp-includes/css/dist/block-library/style.min.css",
    "/wp-includes/css/dist/block-library/theme.min.css",
  ];

  for (const c of css) {
    const link = document.createElement("link");
    link.href = process.env.REACT_APP_DOMAIN + c;
    link.rel = "stylesheet";

    document.head.appendChild(link);
  }
}
